import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const AffiliationTypeConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/affiliation-type",
    component: React.lazy(() => import("./affiliation-type")),
  },
];
